export { default as Image } from "./image";
export * from "./parts/SkeletonImage";
export * from "./types";
export * from "./variants/ImageWithSkeleton";
export { default } from "./variants/ImageWithSkeleton";
